import {useEffect, useState} from 'react'
import {ArrowRight, Play} from 'lucide-react'
import {GetPermissions} from '../../modules/auth'
import FechamentoCover from './FechamentoCover'
import FechamentoViewer from './FechamentoViewer'
import {Fechamento, FECHAMENTOS_PERMISSION, getFechamentoAtivo} from './fechamentosApi'
import './fechamentoAtivoHome.css'

const formatDate = (value: string) => {
  const date = new Date(value)
  return Number.isNaN(date.getTime())
    ? ''
    : date.toLocaleDateString('pt-BR', {day: '2-digit', month: 'short', year: 'numeric'})
}

// Destaque da página inicial: só aparece para quem tem acesso a Fechamentos e quando há um ativo.
export default function FechamentoAtivoHome({delay = 0}: {delay?: number}) {
  const permissions = GetPermissions()
  const allowed = !!permissions?.some((permission) => permission.name === FECHAMENTOS_PERMISSION)
  const [active, setActive] = useState<Fechamento>(null)
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (!allowed) return
    const controller = new AbortController()
    getFechamentoAtivo(controller.signal)
      .then((data) => {
        if (!controller.signal.aborted) setActive(data)
      })
      .catch(() => {})
    return () => controller.abort()
  }, [allowed])

  if (!allowed || !active) return null

  return (
    <>
      <section className='fah' style={{animationDelay: delay + 's'}} aria-label='Fechamento ativo'>
        <button
          type='button'
          className='fah-card'
          onClick={() => setOpen(true)}
          aria-label={'Apresentar fechamento ativo: ' + active.title}
        >
          <span className='fah-cover'>
            <FechamentoCover closing={active} />
            <span className='fah-play' aria-hidden='true'>
              <Play size={18} />
            </span>
          </span>
          <span className='fah-body'>
            <span className='fah-eyebrow'>
              <span className='fah-live' /> Fechamento ativo
            </span>
            <strong className='fah-title' title={active.title}>
              {active.title}
            </strong>
            <span className='fah-meta'>
              {active.pageCount} {active.pageCount === 1 ? 'página' : 'páginas'}
              {formatDate(active.createdAt) && ' · ' + formatDate(active.createdAt)}
            </span>
          </span>
          <span className='fah-cta' aria-hidden='true'>
            <span>Apresentar</span>
            <ArrowRight size={16} />
          </span>
        </button>
      </section>
      {open && <FechamentoViewer closing={active} onClose={() => setOpen(false)} />}
    </>
  )
}
